module.exports = __webpack_public_path__ + "static/Raj Kumar.a1588390.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Raj Kumar.jpg
// module id = 1231
// module chunks = 6166952557895